export const MoonIcon = ({ color = '#FFB82F', ...props }) => (
  <svg
    width={'16'}
    height={'19'}
    viewBox={'0 0 16 19'}
    fill={'none'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path
      d={'M6.2265 2.03574C7.94048 1.08868 9.78084 0.860129 11.4732 1.15905C11.7762 1.21013 11.9217 1.568 11.7281 1.80178C10.0945 3.72771 9.40319 6.39329 10.106 9.01604C10.8087 11.6388 12.7402 13.6016 15.1179 14.4527C15.4102 14.5563 15.4631 14.939 15.2262 15.1347C14.3628 15.8621 13.33 16.42 12.1729 16.73C7.50595 17.9805 2.69121 14.8226 2.16153 9.82189C1.82184 6.67192 3.45091 3.55664 6.2265 2.03574Z'}
      fill={color}
    />
  </svg>
);
